import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import {
  ColorModule,
  MipTranslateModule,
} from '../../directives';
import { TypeOfModule } from '../../pipes';
import { MipCardModule } from '../mip-card';
import { MipLoadingModule } from '../mip-loading';
import { MipModalModule } from '../mip-modal';
import { MipConfirmModalComponent } from './mip-confirm-modal.component';

@NgModule({
  declarations: [MipConfirmModalComponent],
  imports: [
    CommonModule,
    MipModalModule,
    MipCardModule,
    MatButtonModule,
    ColorModule,
    MipLoadingModule,
    TranslateModule,
    MipTranslateModule,
    TypeOfModule,
  ],
  exports: [MipConfirmModalComponent],
})
export class MipConfirmModalModule {}
